import React from "react";
import { motion } from "framer-motion";

export function SurfaceCard({ children, className = "", ...rest }) {
  return (
    <motion.div
      whileHover={{ y: -2 }}
      transition={{ type: "spring", stiffness: 500, damping: 30 }}
      className={
        "rounded-[var(--radius)] bg-[color:var(--surface-1)] border border-[color:var(--border-subtle)] shadow-[var(--shadow-card)] hover:border-[color:var(--border-strong)] hover:shadow-[var(--shadow-hover)] " +
        className
      }
      {...rest}
    >
      {children}
    </motion.div>
  );
}

export function StatusBadge({ status, publishProvider, isSimulated }) {
  const map = {
    draft: {
      cls: "text-[color:var(--text-2)] border-[color:rgba(127,138,163,0.35)] bg-[color:rgba(127,138,163,0.08)]",
      label: "Draft",
    },
    scheduled: {
      cls: "text-[color:var(--info)] border-[color:rgba(77,183,255,0.35)] bg-[color:rgba(77,183,255,0.10)]",
      label: "Scheduled",
    },
    published: {
      cls: "text-[color:var(--success)] border-[color:rgba(47,231,161,0.35)] bg-[color:rgba(47,231,161,0.10)]",
      label: "Published",
    },
    failed: {
      cls: "text-[color:var(--danger)] border-[color:rgba(255,92,108,0.35)] bg-[color:rgba(255,92,108,0.10)]",
      label: "Failed",
    },
    partial_published: {
      cls: "text-[color:var(--accent-warm)] border-[color:rgba(255,138,61,0.35)] bg-[color:rgba(255,138,61,0.10)]",
      label: "Partially published",
    },
    pending_approval: {
      cls: "text-[color:var(--accent-warm)] border-[color:rgba(255,138,61,0.35)] bg-[color:rgba(255,138,61,0.10)]",
      label: "Pending approval",
    },
    // Content-safety Gate B block — post is preserved as a held row and
    // can be edited + retried once the caption is fixed.
    blocked_safety: {
      cls: "text-[color:var(--danger)] border-[color:rgba(255,92,108,0.35)] bg-[color:rgba(255,92,108,0.10)]",
      label: "Held (content review)",
    },
    // Phase 20 — Org compliance Gate C block. Renders the neutral
    // "Compliance review required" wording so users understand this is
    // their business's OWN opt-in policy, not a legal/regulatory ban.
    blocked_org_policy: {
      cls: "text-[color:var(--accent-warm)] border-[color:rgba(255,138,61,0.35)] bg-[color:rgba(255,138,61,0.10)]",
      label: "Compliance review required",
    },
  };
  const info = map[status] || map.draft;
  // Honest labeling for simulated publishes: the ``is_simulated_publish``
  // field is a read-only derived flag from the backend. Never mutates a
  // row. Only relabels the badge, never changes its color scheme.
  let label = info.label;
  let simTestId = "";
  if (status === "published" && isSimulated) {
    const prov = (publishProvider || "").toLowerCase();
    if (prov === "review_demo") {
      label = "Published (review demo)";
      simTestId = "-review-demo";
    } else {
      label = "Published (demo)";
      simTestId = "-demo";
    }
  }
  return (
    <span
      className={"inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium " + info.cls}
      data-testid={`status-badge-${status}${simTestId}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {label}
    </span>
  );
}
